import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

// Locale-aware navigation primitives. Use these in any client/server component
// that lives under app/[locale]/* so links and router calls automatically apply
// the locale prefix per `localePrefix: 'as-needed'` (English stays bare,
// non-English locales get the prefix when added in Stage 3).
//
// Stage 1 creates this module but does not migrate the ~50 existing
// `next/link` / `next/navigation` import sites; that mass sweep happens in
// Stage 2 alongside the strings.ts -> useTranslations migration.
//
// Components under app/admin/* should keep using `next/link` / `next/navigation`
// directly, since admin is excluded from locale routing by design.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
